import gql from 'graphql-tag';

const FRAGMENTS = gql`
  fragment MeetingCredit on meeting_credits {
    id
    user_id
    credit_type
    amount
    description
    created_at
  }
`;

export const GET_STUDENT_CREDITS = gql`
  query getCredits($userId: Int) {
    meeting_credits(
      where: { user_id: { _eq: $userId } }
      order_by: [{ created_at: desc }]
    ) {
      ...MeetingCredit
    }
    usage: v_meeting_credits(where: { user_id: { _eq: $userId } }) {
      user_id
      credit_type
      available
      credit
      debit
    }
  }
  ${FRAGMENTS}
`;

export const LISTEN_STUDENT_CREDITS = gql`
  subscription getCredits($userId: Int) {
    usage: v_meeting_credits(where: { user_id: { _eq: $userId } }) {
      user_id
      credit_type
      available
      credit
      debit
    }
  }
  ${FRAGMENTS}
`;

export const ADD_CREDIT = gql`
  mutation addCredit($input: meeting_credits_insert_input!) {
    insert_meeting_credits_one(object: $input) {
      ...MeetingCredit
    }
  }
  ${FRAGMENTS}
`;
